import { assembleUrlParams, getExperlogixRootUrl } from './urlUtilities';

export const getUrl = (experlogixSiteUrl: string) =>
    `${getExperlogixRootUrl(experlogixSiteUrl)}/site/handlers/eCommerceProductHandler.ashx`;

export const createBody = (itemId: string) => assembleUrlParams({ key: 'ItemId', value: itemId });
